'use client'
import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Cookie } from '@repo/tools'
import { Button, Card, CenterBox, Col, Typography } from '@repo/ui/components'
import Image from 'next/image'

export const RejectedContainer = () => {
  const { t, tRich } = useTranslate()
  const { push } = useRouter()
  const kycReason = Cookie.get('kyc_reason')

  return (
    <Card className='p-xl rounded-sm'>
      <CenterBox className='h-full'>
        <Col className='gap-md items-center'>
          <CenterBox>
            <Image
              src='/images/guard-info.webp'
              alt='hourglass'
              width={80}
              height={80}
            />
          </CenterBox>

          <Typography
            size='md'
            weight='bold'
            color='text-negative-surface-100'
            className='text-center'
          >
            {t('rejected_title')}
          </Typography>
          <Typography
            size='md'
            color='text-neutral-surface-100'
            className='text-center'
          >
            {tRich.rich('rejected_description', {
              reason: () => (
                <span className='text-negative-surface-100'>{kycReason}</span>
              ),
            })}
          </Typography>
          <Button
            variant='fill'
            size='md'
            className='w-full'
            onClick={() => {
              push('/auth/job-qualifications')
            }}
          >
            {t('rejected_action')}
          </Button>
        </Col>
      </CenterBox>
    </Card>
  )
}
